<template>
  <navbar
          position="fixed"
          type="primary"
          :transparent="transparent"
          :color-on-scroll="colorOnScroll"
          menu-classes="ml-auto"
  >
    <template slot-scope="{ toggle, isToggled }">
      <router-link v-popover:popover1 class="navbar-brand" to="/">
        <img src="img/navbar-logo-light.png" class="invision-logo" />
      </router-link>
    </template>
    <template slot="navbar-menu">
      <li class="nav-item">
        <router-link
                to="/about"
                class="nav-link"
        >
          <icon class="fas fa-users" style="transform:scale(1.5);padding-right:5px;"></icon>
          <p>&nbsp;&nbsp;About</p>
        </router-link>
      </li>
      <li class="nav-item">
        <router-link
                to="/sign-in"
                class="nav-link"
        >
          <icon class="fas fa-user" style="transform:scale(1.5);padding-right:5px;"></icon>
          <p>Sign-In</p>
        </router-link>
      </li>
      <li class="nav-item">
        <router-link
                to="/sign-up"
                class="nav-link"
        >
          <icon class="fas fa-user-plus" style="transform:scale(1.5);padding-right:5px;"></icon>
          <p>Sign-Up</p>
        </router-link>
      </li>
      <drop-down
              v-if="this.$store.state.user!==null"
              tag="li"
              title="Account"
              icon="now-ui-icons users_single-02"
              class="nav-item"
              style="padding-right:5px;"
      >
        <nav-link to="/profile">
          Profile
        </nav-link>
        <nav-link to="/thank-you" @click="signout">
          Sign-Out
        </nav-link>
      </drop-down>
      <li class="nav-item">
        <a
                class="nav-link"
                rel="tooltip"
                title="Follow us on Twitter"
                data-placement="bottom"
                href="https://twitter.com/transpo_india"
                target="_blank"
        >
          <i class="fab fa-twitter"></i>
          <p class="d-lg-none d-xl-none">Twitter</p>
        </a>
      </li>
      <li class="nav-item">
        <a
                class="nav-link"
                rel="tooltip"
                title="Like us on Facebook"
                data-placement="bottom"
                href="https://www.facebook.com/india.transpo"
                target="_blank"
        >
          <i class="fab fa-facebook-square"></i>
          <p class="d-lg-none d-xl-none">Facebook</p>
        </a>
      </li>
      <li class="nav-item">
        <a
                class="nav-link"
                rel="tooltip"
                title="Follow us on Instagram"
                data-placement="bottom"
                href="https://www.instagram.com/transpoindia"
                target="_blank"
        >
          <i class="fab fa-instagram"></i>
          <p class="d-lg-none d-xl-none">Instagram</p>
        </a>
      </li>
      <li class="nav-item">
        <a
                class="nav-link"
                rel="tooltip"
                title="Connect on LinkedIn"
                data-placement="bottom"
                href="https://www.linkedin.com/company/transpo/"
                target="_blank"
        >
          <i class="fab fa-linkedin"></i>
          <p class="d-lg-none d-xl-none">Linkedin</p>
        </a>
      </li>
    </template>
  </navbar>
</template>

<script>
  import { DropDown, NavbarToggleButton, Navbar, NavLink } from '@/components';
  import { Popover } from 'element-ui';
  export default {
    name: 'main-navbar',
    props: {
      transparent: Boolean,
      colorOnScroll: Number
    },
    components: {
      DropDown,
      Navbar,
      NavbarToggleButton,
      NavLink,
      [Popover.name]: Popover
    }
  };
</script>

<style>
  .navbar {
    height:80px!important;
  }
</style>
